import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { MatSortModule } from "@angular/material/sort";
import { MatGridListModule } from "@angular/material/grid-list";
import { FlexLayoutModule } from "ngx-flexible-layout";
import { MatCardModule as MatCardModule } from "@angular/material/card";
import { MatIconModule } from "@angular/material/icon";
import { MatProgressSpinnerModule as MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatProgressBarModule as MatProgressBarModule } from "@angular/material/progress-bar";
import { MatFormFieldModule as MatFormFieldModule } from "@angular/material/form-field";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatInputModule as MatInputModule } from "@angular/material/input";
import { MatButtonModule as MatButtonModule } from "@angular/material/button";
import { MatNativeDateModule } from "@angular/material/core";
import { MatCheckboxModule as MatCheckboxModule } from "@angular/material/checkbox";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatBadgeModule } from "@angular/material/badge";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatMenuModule as MatMenuModule } from "@angular/material/menu";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatRadioModule as MatRadioModule } from "@angular/material/radio";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatTooltipModule as MatTooltipModule } from "@angular/material/tooltip";
import { NgxPrintModule } from "ngx-print";
import { MatSelectModule as MatSelectModule } from "@angular/material/select";
import { MatDividerModule } from "@angular/material/divider";
import { MatDialogModule as MatDialogModule } from "@angular/material/dialog";
import { MatTableModule as MatTableModule } from "@angular/material/table";
import { MatPaginatorModule as MatPaginatorModule } from "@angular/material/paginator";
import { ColorPickerModule } from "ngx-color-picker";
import { DragDropModule } from "@angular/cdk/drag-drop";

import { AutocompleteComponent } from "./google-places.component";
import {
  EditApplicabilityComponent,
  DisplayApplicabilityReviewDialog,
} from "./edit-applicability/edit-applicability.component";
import { AnswerQuestionComponent } from "./edit-applicability/answer-question/answer-question.component";
import { ParagraphChecklistComponent } from "./edit-applicability/answer-question/paragraph-checklist/paragraph-checklist.component";
import { ListRulebookComponent } from "./edit-applicability/list-rulebook/list-rulebook.component";
import {
  EditTemplateComponent,
  StateListDialog,
  DisplayReviewDialog,
  PreAnswerListDialog,
  ConfirmBuildDialog,
} from "./edit-template/edit-template.component";
import { NewAuditComponent } from "./new-audit/new-audit.component";
import { ConfirmDialog } from "./new-audit/new-audit.component";
import {
  ViewRulebooksComponent,
  StateDialog,
} from "./view-rulebooks/view-rulebooks.component";
import { RulebookContentComponent } from "./view-rulebooks/rulebook-content/rulebook-content.component";
import { RulebookListComponent } from "./view-rulebooks/rulebook-list/rulebook-list.component";
import {
  ParaDisplayDialog,
  ViewCitationsComponent,
} from "./view-citations/view-citations.component";
import {
  CustomQuestionsComponent,
  NewTopicDialog,
} from "./custom-questions/custom-questions.component";
import { EditCustomComponent } from "./custom-questions/edit-custom/edit-custom.component";
import { ListCustomComponent } from "./custom-questions/list-custom/list-custom.component";
import {
  RankAndScoreComponent,
  NewTemplateDialog,
  EditTemplateDialog,
} from "./rank-and-score/rank-and-score.component";
import { ListScoringComponent } from "./rank-and-score/list-scoring/list-scoring.component";
import {
  EditRankingDialog,
  EditScoringComponent,
  EditScoringDialog,
} from "./rank-and-score/edit-scoring/edit-scoring.component";
import { DownloadListDialog } from "./apptool.component";
import { BuildStatusComponent } from "../build-status/build-status.component";
import { OpenAuditComponent } from "./open-audit/open-audit.component";
import { PubviewTrackComponent } from "../pubview-track/pubview-track.component";
import { BadgeModule } from "primeng/badge";

@NgModule({
  declarations: [
    AutocompleteComponent,
    EditTemplateComponent,
    EditApplicabilityComponent,
    DisplayApplicabilityReviewDialog,
    AnswerQuestionComponent,
    ParagraphChecklistComponent,
    ListRulebookComponent,
    NewAuditComponent,
    ConfirmDialog,
    StateListDialog,
    StateDialog,
    PreAnswerListDialog,
    ConfirmBuildDialog,
    ViewRulebooksComponent,
    RulebookContentComponent,
    RulebookListComponent,
    ViewCitationsComponent,
    CustomQuestionsComponent,
    EditCustomComponent,
    ListCustomComponent,
    NewTopicDialog,
    EditRankingDialog,
    DisplayReviewDialog,
    EditScoringDialog,
    RankAndScoreComponent,
    ListScoringComponent,
    EditScoringComponent,
    NewTemplateDialog,
    EditTemplateDialog,
    ParaDisplayDialog,
    DownloadListDialog,
    BuildStatusComponent,
    PubviewTrackComponent,
    OpenAuditComponent,
  ],
  imports: [
    RouterModule,
    CommonModule,
    MatGridListModule,
    FlexLayoutModule,
    MatRadioModule,
    MatCardModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatInputModule,
    MatNativeDateModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatDividerModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatRadioModule,
    MatButtonModule,
    MatBadgeModule,
    MatMenuModule,
    MatToolbarModule,
    MatButtonToggleModule,
    MatTooltipModule,
    MatSelectModule,
    MatGridListModule,
    FormsModule,
    ReactiveFormsModule,
    NgxPrintModule,
    MatDialogModule,
    ColorPickerModule,
    DragDropModule,
    BadgeModule,
  ],
})
export class ApptoolModule {}
